import { render, staticRenderFns } from "./bottomLeft2.vue?vue&type=template&id=2c96582c&scoped=true&"
import script from "./bottomLeft2.vue?vue&type=script&lang=js&"
export * from "./bottomLeft2.vue?vue&type=script&lang=js&"
import style0 from "./bottomLeft2.vue?vue&type=style&index=0&id=2c96582c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c96582c",
  null
  
)

export default component.exports